/* Sassies Prentenboeken — thema-interactie (vanilla JS, geen dependencies) */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobiel menu ---------- */
  var menuKnop = document.querySelector('[data-mobiel-menu-knop]');
  var mobielMenu = document.querySelector('[data-mobiel-menu]');
  if (menuKnop && mobielMenu) {
    menuKnop.addEventListener('click', function () {
      mobielMenu.hidden = !mobielMenu.hidden;
    });
  }

  /* ---------- Variantkeuze op productpagina ---------- */
  var productFormulier = document.getElementById('product-formulier');
  if (productFormulier) {
    var variantenScript = document.querySelector('[data-product-varianten]');
    var varianten = variantenScript ? JSON.parse(variantenScript.textContent) : [];
    var selectors = Array.prototype.slice.call(document.querySelectorAll('[data-optie-selector]'));
    var variantIdVeld = document.getElementById('product-variant-id');
    var prijsElement = document.getElementById('product-prijs');
    var koopKnop = document.querySelector('[data-koop-knop]');
    var koopKnopTekst = document.querySelector('[data-koop-knop-tekst]');
    var hoofdbeeld = document.getElementById('product-hoofdbeeld');

    function huidigeSelectie() {
      return selectors.map(function (select) { return select.value; });
    }

    function vindVariant() {
      var selectie = huidigeSelectie();
      return varianten.find(function (variant) {
        return variant.options.every(function (waarde, index) {
          return selectie[index] === undefined || waarde === selectie[index];
        });
      });
    }

    function werkBij() {
      var variant = vindVariant();
      if (!variant) return;

      variantIdVeld.value = variant.id;

      if (prijsElement) {
        prijsElement.textContent = formatteerPrijs(variant.price);
      }

      if (koopKnop) {
        koopKnop.disabled = !variant.available;
        if (koopKnopTekst) {
          koopKnopTekst.textContent = variant.available ? 'In winkelwagen' : 'Uitverkocht';
        }
      }

      if (variant.featured_image && hoofdbeeld) {
        hoofdbeeld.src = variant.featured_image.src;
      }
    }

    function formatteerPrijs(centen) {
      var euro = (centen / 100).toFixed(2).replace('.', ',');
      return '€ ' + euro;
    }

    selectors.forEach(function (select) {
      select.addEventListener('change', werkBij);
    });

    /* AJAX toevoegen aan winkelwagen */
    productFormulier.addEventListener('submit', function (event) {
      event.preventDefault();
      var formData = new FormData(productFormulier);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          werkWinkelwagenTellerBij();
          toonWinkelwagenMelding();
        })
        .catch(function () {
          productFormulier.submit();
        });
    });
  }

  /* ---------- Miniatuur-afbeeldingen op productpagina ---------- */
  var hoofdbeeldEl = document.getElementById('product-hoofdbeeld');
  document.querySelectorAll('[data-miniatuur]').forEach(function (knop) {
    knop.addEventListener('click', function () {
      if (hoofdbeeldEl) hoofdbeeldEl.src = knop.getAttribute('data-src');
      document.querySelectorAll('[data-miniatuur]').forEach(function (b) { b.classList.remove('is-actief'); });
      knop.classList.add('is-actief');
    });
  });

  /* ---------- Winkelwagen-teller & melding ---------- */
  function werkWinkelwagenTellerBij() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-winkelwagen-teller]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function toonWinkelwagenMelding() {
    var melding = document.getElementById('winkelwagen-melding');
    if (!melding) return;
    melding.hidden = false;
    requestAnimationFrame(function () { melding.setAttribute('data-zichtbaar', ''); });
    clearTimeout(melding._timer);
    melding._timer = setTimeout(function () {
      melding.removeAttribute('data-zichtbaar');
      setTimeout(function () { melding.hidden = true; }, 300);
    }, 3200);
  }

  /* ---------- Winkelwagenpagina: aantal wijzigen ---------- */
  document.querySelectorAll('[data-winkelwagen-aantal]').forEach(function (input) {
    input.addEventListener('change', function () {
      var regel = parseInt(input.getAttribute('data-regel'), 10) + 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: regel, quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Kijkje in het boek: flip-through preview ---------- */
  document.querySelectorAll('[data-kijkje-boek]').forEach(function (boek) {
    var paginas = Array.prototype.slice.call(boek.querySelectorAll('[data-kijkje-pagina]'));
    var stippenWrapper = boek.parentElement.querySelector('[data-kijkje-stippen]');
    var stippen = stippenWrapper ? Array.prototype.slice.call(stippenWrapper.querySelectorAll('.kijkje__stip')) : [];
    var huidig = 0;

    function toonPagina(index) {
      if (index < 0 || index >= paginas.length) return;
      huidig = index;
      paginas.forEach(function (p, i) { p.classList.toggle('is-actief', i === index); });
      stippen.forEach(function (s, i) { s.classList.toggle('is-actief', i === index); });
    }

    var vorigeKnop = boek.querySelector('[data-kijkje-vorige]');
    var volgendeKnop = boek.querySelector('[data-kijkje-volgende]');
    if (vorigeKnop) vorigeKnop.addEventListener('click', function () { toonPagina(huidig - 1); });
    if (volgendeKnop) volgendeKnop.addEventListener('click', function () { toonPagina(huidig + 1); });
    stippen.forEach(function (stip, i) { stip.addEventListener('click', function () { toonPagina(i); }); });
  });

});
